<template>
    <div>
        <CRow>
            <CCol>
                <ejs-grid v-if="!hasPriceAreas" ref='grid'
                          :dataSource='volumesLogsData' :allowFiltering='true' :allowPaging='true' :allowResizing='true' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :actionFailure="actionFailure"
                          :pageSettings='pageSettings' :filterSettings='filterOptions' :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete'
                          :query='gridQuery' :actionComplete="actionComplete" :queryCellInfo='customiseCell' :excelQueryCellInfo='excelQueryCellInfo'>
                    <e-columns>
                        <e-column field='volumeId' headerText='volumeId' :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='tradablePeriod' headerText='Tradeable Period' width=120></e-column>
                        <e-column field='base' headerText='Base' format="n2" :visible='baseVisible' width=120></e-column>
                        <e-column field='peak' headerText='Peak' format="n2" :visible='peakVisible' width=120></e-column>
                        <e-column field='gas' headerText='Gas' format="n2" :visible='gasVisible' width=120></e-column>
                        <e-column field='offPeak' headerText='Off-Peak' format="n2" :visible='offPeakVisible' width=120></e-column>
                        <e-column field='total' headerText='Total' format="n2" :visible='totalVisible' width=120></e-column>
                        <e-column field='logDate' headerText='Log Date' textAlign='Left' width=120 type="date" :format='dateFormatOptions'></e-column>
                        <e-column field='logTime' headerText='Log Time' textAlign='Left' type='string' width=120></e-column>
                        <e-column field='userName' headerText='User' textAlign='Left' width=120 type="string"></e-column>
                    </e-columns>
                </ejs-grid>
                <ejs-grid v-if="hasPriceAreas" ref='gridWithPriceAreas'
                          :dataSource='volumesLogsDataWithPriceArea' :allowFiltering='true' :allowPaging='true' :allowResizing='true' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :actionFailure="actionFailure" :toolbarClick="secondGridToolbarClick"
                          :pageSettings='pageSettings' :filterSettings='filterOptions' :allowExcelExport='true' :query='gridQuery' :actionComplete="actionComplete" :queryCellInfo='customiseCell' :excelQueryCellInfo='excelQueryCellInfo'>
                    <e-columns>
                        <e-column field='id' headerText='volumeId' :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='priceAreaVolumeId' headerText='Price Area Volume Id' width="120"></e-column>
                        <e-column field='tradablePeriod' headerText='Tradeable Period' width=120></e-column>
                        <e-column field='product' headerText='Product' format="n2" width=120></e-column>
                        <e-column field='value' headerText='Value' format="n2" width=120></e-column>
                        <e-column field='priceAreaName' headerText='Price Area' width=120></e-column>
                        <e-column field='logDate' headerText='Log Date' textAlign='Left' width=120 type="date" :format='dateFormatOptions'></e-column>
                        <e-column field='logTime' headerText='Log Time' textAlign='Left' type='string' width=120></e-column>
                        <e-column field='userName' headerText='User' textAlign='Left' width=120 type="string"></e-column>
                    </e-columns>
                </ejs-grid>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { GridPlugin, Toolbar, Page, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from '@syncfusion/ej2-vue-grids';
    import { Query } from '@syncfusion/ej2-data';
    import store from '../../store';
    import dates from '../../common/dates';
    import gridOptions from '../../common/gridOptions';
    import SyncHelper from '../../common/syncfusion';
    import authToken from '../../common/authToken';
    import apis from '../../common/network';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(GridPlugin);

    export default {
        components: {

        },
        created() {

            apis.protectedApi(`utils/products?utilityTypeId=${store.state.contractSelectedUtility}`)
                .then(response => {
                    if (response.data) {
                        response.data.forEach(p => {
                            if (store.state.contractProducts.includes(p.id)) {
                                this.selectedProducts.push(p.productName);
                            }
                        })
                    }
                }).catch(e => {
                    if (e.response) {
                        this.showErrorDialog(e.response.data.message);
                    }
                })
        },
        data() {
            return {
                store: store,
                volumesLogsData: SyncHelper.getDataManager("volumeLog"),
                volumesLogsDataWithPriceArea: SyncHelper.getDataManager("priceAreaVolumeLog"),
                pageSettings: gridOptions.pageSettings,
                filterOptions: gridOptions.filterSettings,
                toolbar: ['ExcelExport'],
                gridQuery: new Query().addParams("contractId", store.state.selectedContractId),
                addHeaders: function (args) {
                    args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);

                },
                selectedProducts: [],
                volumeUnit: store.state.contractVolumeUnit,
                volumeUnitFromLog: "",
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                hasPriceAreas: false
            };
        },
        methods: {
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            actionComplete(args) {
                gridOptions.actionComplete(args);
            },
            toolbarClick: function (args) {
                if (args.item.id.includes('excelexport')) {
                    this.$refs.grid.getColumns()[0].visible = true;
                }
                gridOptions.excelExport(args, "Volume Logs.xlsx", this.$refs);
            },
            excelExportComplete: function () {
                this.$refs.grid.getColumns()[0].visible = false;
                this.$refs.grid.hideSpinner();

            },
            secondGridToolbarClick: function (args) {
                if (args.item.id.includes('excelexport')) {
                    let excelExportProperties = {
                        fileName: "Volume Logs.xlsx"
                    };
                    this.$refs.gridWithPriceAreas.excelExport(excelExportProperties);
                }
            },
            customiseCell: function (args) {
                if (args.column.field === 'base'
                    || args.column.field === 'peak'
                    || args.column.field === 'gas'
                    || args.column.field === 'offPeak'
                    || args.column.field === 'total'
                    || args.column.field === 'value')
                {
                    this.volumeUnitFromLog = args.data.volumeUnit;
                    if (this.volumeUnitFromLog != undefined && this.volumeUnitFromLog != this.volumeUnit) {
                        args.cell.textContent = args.cell.textContent + " " + "[" + this.volumeUnitFromLog + "]";
                    }
                    else {
                        args.cell.textContent = args.cell.textContent + " " + "[" + this.volumeUnit + "]";
                    }
                }
                if (args.column.field === 'logTime') {
                    args.cell.textContent = this.convertUTCDateToLocalTime(args.data['logTime']);
                }
            },
            excelQueryCellInfo(args) {

                if (args.column.field === 'logTime') {
                    args.value = this.convertUTCDateToLocalTime(args.data['logTime']);
                }
            },
            convertUTCDateToLocalTime(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleTimeString();
            },
            getContractPriceAreas(contractId) {
                apis.protectedApi(`utils/ContractHasAreas?contractId=${contractId}`)
                    .then(response => {
                        this.hasPriceAreas = response.data.contractHasAreas;
                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
            }
        },
        computed: {
            baseVisible() {
                return this.selectedProducts.includes("Baseload");
            },
            peakVisible() {
                return this.selectedProducts.includes("Peakload");
            },
            gasVisible() {
                return this.selectedProducts.includes("Gas");
            },
            offPeakVisible() {
                return this.selectedProducts.includes("Off-Peak");
            },
            totalVisible() {
                return this.selectedProducts.length > 1
            },

        },
        mounted() {
            this.getContractPriceAreas(this.$store.state.selectedContractId);
        },
        provide: {
            grid: [Page, Toolbar, ExcelExport, Filter, Sort, Reorder, Resize, ForeignKey ]
        }
    };


</script>

<style scoped>
</style>